import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
  Input,
  Button,
  NotificationBanner,
  ErrorSummary,
} from 'govuk-react-jsx';
import { useDispatch, useSelector } from 'react-redux';

import {
  getAccountMobileNumber,
  setAccessCodeMobile,
  getAccessCodeMobile,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkMobileNumber, resendCode } from '../../firebase';
import { checkValidSmsCode } from '../../regex/regex';
import useTitle from '../../hooks/useTitle';

const AccessCodeMobile = () => {
  const [success, setSuccess] = useState(false);
  const accountMobileNumberRedux = useSelector(getAccountMobileNumber);
  const accessCodeMobileRedux = useSelector(getAccessCodeMobile);
  const [errMessage, setErrMessage] = useState(false);
  const [errorList, setErrorList] = useState([]);

  const dispatch = useDispatch();
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.AccessCodeMobile.s11',
    'Enter your mobile access code - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const errorMessage = copyProvider.getCopy(
    'landlordReg.AccessCodeMobile.s8',
    'Enter a valid access code.'
  );

  const updatedAccessCodeMobile = (event) => {
    dispatch(setAccessCodeMobile(event.target.value));
  };

  let accountMobileNumberDisplay = accountMobileNumberRedux;
  if (
    accountMobileNumberDisplay.length === 10 &&
    accountMobileNumberRedux.charAt(0) !== '0'
  ) {
    accountMobileNumberDisplay = `0${accountMobileNumberDisplay}`;
  }

  const handleBtnClick = () => {
    const valid = checkValidSmsCode.test(accessCodeMobileRedux);
    if (valid) {
      checkMobileNumber({ mobileOtp: accessCodeMobileRedux })
        .then(() => {
          dispatch(setAccessCodeMobile(accessCodeMobileRedux));
          setErrMessage(null);
          history.push('/landlordReg/mobile-verified');
        })
        .catch(() => {
          // TODO: add error when the server is not responding
          // TODO: add error if the code is not valid
          setErrMessage({
            children: errorMessage,
          });
          setErrorList([
            { children: errorMessage, href: '#input-with-error-message' },
          ]);
        });
    } else {
      setErrMessage({
        children: errorMessage,
      });
      setErrorList([
        { children: errorMessage, href: '#input-with-error-message' },
      ]);
    }
  };

  const resendText = () => {
    resendCode({ type: 'phone' })
      .then(() => {
        setSuccess(true);
      })
      .catch(() => {
        // TODO: Show error message
        setSuccess(true);
      });
  };

  const title = copyProvider.getCopy(
    'landlordReg.AccessCodeMobile.s9',
    'Mobile code has been sent again'
  );

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      {success && (
        <NotificationBanner type="success" titleChildren={title}>
          <p className="govuk-body">
            {copyProvider.getCopy(
              'landlordReg.AccessCodeMobile.s10',
              'We have sent you a new verification code via text, this may take a few minutes to arrive.'
            )}
          </p>
        </NotificationBanner>
      )}
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.AccessCodeMobile.s1',
          'Enter your mobile access code'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.AccessCodeMobile.s2',
          'We have sent a text message to '
        )}
        <b>
          {accountMobileNumberRedux.length === 11
            ? `${accountMobileNumberRedux.slice(
                0,
                5
              )}  ${accountMobileNumberRedux.slice(
                5,
                8
              )} ${accountMobileNumberRedux.slice(8, 11)}`
            : `0${accountMobileNumberRedux.slice(
                0,
                4
              )}  ${accountMobileNumberRedux.slice(
                4,
                7
              )}  ${accountMobileNumberRedux.slice(7, 11)}`}
        </b>{' '}
        {copyProvider.getCopy(
          'landlordReg.AccessCodeMobile.s3',
          'with a 6 digit verification code'
        )}
      </p>
      <p className="govuk-body govuk-second">
        {copyProvider.getCopy(
          'landlordReg.AccessCodeMobile.s4',
          'It may take a few minutes to arrive.'
        )}
      </p>
      <div className="govuk-form-group">
        <Input
          className="govuk-input govuk-input--width-10"
          errorMessage={errMessage || null}
          label={{
            children: copyProvider.getCopy(
              'landlordReg.AccessCodeMobile.s5',
              'Verification code'
            ),
          }}
          maxLength={6}
          id="input-with-error-message"
          name="access-code"
          // TODO: do not display access code when returning to this page
          value={accessCodeMobileRedux}
          onChange={(event) => updatedAccessCodeMobile(event)}
        />
      </div>
      <p>
        <Link
          className="govuk-body"
          onClick={() => resendText()}
          to="/landlordReg/access-code-mobile"
        >
          {copyProvider.getCopy(
            'landlordReg.AccessCodeMobile.s6',
            'I have not received the verification code'
          )}
        </Link>
      </p>

      <div className="govuk-button-group">
        <Button
          className="govuk-button"
          data-module="govuk-button"
          onClick={handleBtnClick}
        >
          {copyProvider.getCopy('landlordReg.AccessCodeMobile.s7', 'Continue')}
        </Button>
      </div>
    </>
    // )
  );
  return pageModel;
};

export default AccessCodeMobile;
